import React from 'react';
import { useSelector } from 'react-redux';
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { filterActiveOptions } from "../../../helpers/functions";
import { FormGroup } from 'arag-ui-lib';
import QuestionEditActions from "../QuestionEditActions";
import { INITIAL_OPTIONS, WORK_SOURCE_ID_MN } from "../../../helpers/constants";
import CONTENT_STRINGS from "../../../helpers/contentStrings";
import { isPigLockedQuestion } from "../../../helpers/pigLock";
import SharedApplicationFormQuestions from '../sharedApplicationFormQuestions';
const DropdownInputType = (props) => {
    const {
        question,
        value,
        formData,
        isPlain,
        application,
        questions,
        attachments,
        hasInlineElements,
        selectHandler,
        workSourceOptions,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        openEditQuestionAnswerModal,
        openDeleteAnswerModal,
        openHistoryModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        checkIfQuestionsHasBeenModified,
        checkIfQuestionIsEditable,
        getApprovalSettings,
        isAnswerEditModalOpen,
        isLabelClickable,
        // Props for child questions rendering
        dateHandler,
        textHandler,
        onDrop,
        handleBlur,
        medicalExpertFees,
        breachCausationCp,
        handleMedicalFeesTableRows,
        handleEditRowClick,
        medicalFeesTableHandler,
        downLoadFile,
        onAttachmentRequest,
        multipleFilesAllowed,
        fileDisabled,
        validateAmountTypeQuestion,
        questionValidation,
        textAreaRows,
        onClickActionLink,
        opponents,
        opponentHandler,
        onOpponentAdd,
        opponentQuestions,
    } = props;

    let selectedOption;
    let dropdownOptions;
    const selectedOptionId = value;
    const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.SELECT;

    // WI 95280: a locked question can still reach the answer-edit modal as the *child* of an unlocked
    // parent - editing "Likely claims track" renders its Damages child - so the lock has to be applied
    // here as well as on the pencil. Only in the editable (non-plain) render: the plain Application-tab
    // row already shows its tooltip through QuestionEditActions, and a second one would double up.
    const selectedApplication = useSelector(state => state.newApplication.selectedApplication);
    const isPigLocked = !isPlain && isPigLockedQuestion(question.machineName, selectedApplication);

    // Handle special cases for non-standard questions
    if (!question.isStandard) {
        selectedOption = question.options.find(o => 
            o.id && selectedOptionId && o.id.toString() === selectedOptionId.toString()
        );
    } else {
        selectedOption = question.options.find(o => o.id === selectedOptionId);
    }

    // Build dropdown options - filter to only show active options, but always include the currently selected option
    if (question.machineName === WORK_SOURCE_ID_MN) {
        dropdownOptions = workSourceOptions || [];
    } else {
        const questionOptions = filterActiveOptions(question.options, selectedOptionId)
            .map(option => ({
                key: option.id,
                label: option.name
            }));
        dropdownOptions = [
            ...INITIAL_OPTIONS,
            ...questionOptions
        ];
    }

    // Get child questions if an option is selected
    let optionChildQuestions = [];
    if (selectedOption && selectedOption.childQuestions) {
        optionChildQuestions = selectedOption.childQuestions;
    }

    return (
        <>
            <FormGroup
                variant={variant}
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={question.name}
                inputProps={{
                    id: `question-id-${question.id}`,
                    name: question.machineName,
                    required: question.isRequired,
                    label: selectedOption ? selectedOption.name : '',
                    value: selectedOptionId,
                    options: dropdownOptions,
                    onChange: (evt) => selectHandler(question.id, evt.target.value),
                    disabled: isPigLocked,
                }}
                infoText={isPigLocked ? CONTENT_STRINGS.PIG_APPLIED_EDIT_LOCKED_TOOLTIP : undefined}
                tooltipTestId={`policy-application-${question.machineName}-info`}
                hasInlineElements={hasInlineElements}
                inlineGroupElements={
                    hasInlineElements 
                    ?
                        <div className={"col-sm-3"}>
                            <QuestionEditActions
                                checkIfPlainEditable={checkIfPlainEditable(question, question.machineName)}
                                question={question}
                                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                approvalOptions={approvalOptions}
                                onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                                hasPendingChanges={checkIfQuestionHasPendingChanges( question.id, application )}
                                
                            />
                        </div>
                    : 
                        null
                }
                onLabelClick={ isLabelClickable ? () => openHistoryModal(question) : undefined }
                formGroupTestId={`policy-application-${question.machineName}`}
            />
            
            {/* Render child questions */}
            {optionChildQuestions.length > 0 
            ?
                <>
                    {optionChildQuestions.map(childQuestion => {
                        // Check if Child Question has been modified (has history/revisions)
                        const isChildLabelClickable = checkIfQuestionsHasBeenModified(childQuestion.id, application);
                        return (
                            <SharedApplicationFormQuestions
                                key={childQuestion.id}
                                question={childQuestion}
                                formData={formData}
                                isPlain={isPlain}
                                value={formData[childQuestion.id]}
                                application={application}
                                questions={questions}
                                attachments={attachments}
                                openDeleteAnswerModal={openDeleteAnswerModal}
                                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                                openHistoryModal={openHistoryModal}
                                isAnswerEditModalOpen={isAnswerEditModalOpen}
                                isLabelClickable={isChildLabelClickable}
                                hasInlineElements={hasInlineElements}
                                dateHandler={dateHandler}
                                textHandler={textHandler}
                                selectHandler={selectHandler}
                                onDrop={onDrop}
                                handleBlur={handleBlur}
                                medicalExpertFees={medicalExpertFees}
                                breachCausationCp={breachCausationCp}
                                handleMedicalFeesTableRows={handleMedicalFeesTableRows}
                                handleEditRowClick={handleEditRowClick}
                                medicalFeesTableHandler={medicalFeesTableHandler}
                                downLoadFile={downLoadFile}
                                onAttachmentRequest={onAttachmentRequest}
                                multipleFilesAllowed={multipleFilesAllowed}
                                fileDisabled={fileDisabled}
                                validateAmountTypeQuestion={validateAmountTypeQuestion}
                                questionValidation={questionValidation}
                                workSourceOptions={workSourceOptions}
                                textAreaRows={textAreaRows}
                                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                approvalOptions={approvalOptions}
                                getApprovalSettings={getApprovalSettings}
                                checkIfPlainEditable={checkIfPlainEditable}
                                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                                checkIfQuestionsHasBeenModified={checkIfQuestionsHasBeenModified}
                                checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                                onClickActionLink={onClickActionLink}
                                opponents={opponents}
                                opponentHandler={opponentHandler}
                                onOpponentAdd={onOpponentAdd}
                                opponentQuestions={opponentQuestions}
                            />
                        );
                    })}
                </>
            :
                null
            }
        </>
    );
};

export default DropdownInputType;